import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08b25788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locus" }
const _hoisted_2 = {
  id: "map_locus",
  class: "map_locus"
}
const _hoisted_3 = { class: "locus-type" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "select-box" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "operation" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "header" }
const _hoisted_14 = { class: "dialog-footer" }

import { onMounted, ref, computed } from 'vue'
import {
  queryLocusAoiAll,
  locusAoiUpdate,
  locusDelete,
  queryAllDevice,
} from '@/api'
import LocusInfo from './components/locus-info.vue'
import {
  CODE_ENUM,
  LOCUS_SHAPE_TYPE,
  LOCUS_DIRECTION_TYPE,
} from '@/common/enum'
import { ElMessage } from 'element-plus'
import moment from 'moment'
import MapControl from '@/components/map-control'
import {
  createPopup,
  createMap,
  getDeviceClass,
  formatLat,
  formatLng,
} from '@/utils/map.utils'
import 'leaflet-draw'
import '@/styles/leaflet.draw.css'
import i18n from '@/i18n'
import Text from '@/components/text'
import L from 'leaflet'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const locusType = ref([
  {
    class: LOCUS_SHAPE_TYPE.POLYGON,
    title: t('D_LOCUS.polygon'),
  },
  {
    class: LOCUS_SHAPE_TYPE.ROUND,
    title: t('D_LOCUS.round'),
  },
])
const locusTypeValue = ref(LOCUS_SHAPE_TYPE.POLYGON)
const locusTypeActive = (value: any) => {
  return locusTypeValue.value === value
}

const changeLocusType = (value: any) => {
  locusTypeValue.value = value

  locusTypeChange()
}

// leaflet Map
L.drawLocal.draw.handlers.polygon.tooltip = {
  start: t('D_LOCUS.drawStartTip'),
  cont: t('D_LOCUS.drawContTip'),
  end: t('D_LOCUS.drawEndTip'),
}

L.drawLocal.draw.handlers.circle.tooltip = {
  start: t('D_LOCUS.circleTip1'),
}
L.drawLocal.draw.handlers.simpleshape.tooltip.end = t('D_LOCUS.circleTip2')
L.drawLocal.draw.handlers.circle.radius = t('D_LOCUS.radius')

// 可以重写原形链
// L.Draw.Circle.prototype._onMouseMove = function (e: any) {}
// L.Draw.Circle.prototype._fireCreatedEvent = function (e: any) {
// }

let map: any = null
onMounted(async () => {
  map = createMap('map_locus')
  map.on('draw:created', onDrawCreated)

  await Promise.all([fetchList(), queryDevice()])
  autoViewport()
})

const locusInfoConf = ref({
  visible: false,
  data: {},
})

const OPEERATION_ENUM = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  EMPTY: 'EMPTY',
}

const derectionMap = {
  [LOCUS_DIRECTION_TYPE.IN]: {
    class: 'in',
    label: t('D_LOCUS.typeIn'),
    color: '#33FF28',
    fillColor: '#33FF28',
  },
  [LOCUS_DIRECTION_TYPE.OUT]: {
    class: 'out',
    label: t('D_LOCUS.typeOut'),
    color: '#287EFF',
    fillColor: '#287EFF',
  },
  [LOCUS_DIRECTION_TYPE.IN_AND_OUT]: {
    class: 'in-out',
    label: t('D_LOCUS.typeInOut'),
    color: '#FF7328',
    fillColor: '#FF7328',
  },
}
// 获取方向的描述
const getDirectionDesc = (directionType: string, key?: string) => {
  return key ? derectionMap[directionType][key] : derectionMap[directionType]
}

const currentStep = ref(OPEERATION_ENUM.EMPTY)

const editLoading = ref(false)
//修改电子围栏坐标范围
const toLocusAoiUpdate = async (params: any) => {
  const { id } = editInstance.value
  editLoading.value = true
  const res: any = await locusAoiUpdate({
    aoiId: id,
    ...params,
  }).finally(() => {
    editLoading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    onLocusInfoSuccess()
  }
}

const filterLocus = ref('')
const filterLocusList = computed(() => {
  return filterLocus.value
    ? locusList.value.filter((item: any) => {
        return item.id === filterLocus.value
      })
    : locusList.value
})

const locusList: any = ref([])
const locusMap: any = ref({})

const fetchList = async () => {
  const res: any = await queryLocusAoiAll()
  if (res?.code === CODE_ENUM.SUCCESS) {
    locusList.value = res?.data || []
    renderLocusList()
  }
}

// 渲染围栏
const renderLocusList = () => {
  removeLocusList()

  locusMap.value = {}
  locusList.value.forEach(
    ({ aoiGraphCode, poiInfos = [], id, roundData, aoiDirectionCode }: any) => {
      const { color, fillColor } = getDirectionDesc(aoiDirectionCode)
      let overlay = null
      if (aoiGraphCode === LOCUS_SHAPE_TYPE.POLYGON) {
        const points = poiInfos.map(({ longitude, latitude }: any) => {
          return [latitude, longitude]
        })
        overlay = new L.Polygon(points, {
          color,
          fillColor,
        })
      } else if (aoiGraphCode === LOCUS_SHAPE_TYPE.ROUND) {
        overlay = new L.circle(
          [roundData.latitude, roundData.longitude],
          roundData.radius,
          {
            color,
            fillColor,
          }
        )
      }
      // 记录实例
      overlay.aoiGraphCode = aoiGraphCode
      locusMap.value[id] = overlay
      map.addLayer(overlay)
    }
  )
}

const removeLocusList = (exceptId?: any) => {
  let exceptInstance = null
  locusList.value.forEach(({ id }: any) => {
    const overlay = locusMap.value[id]
    if (exceptId !== id) {
      overlay?.remove?.()
    } else {
      map.addLayer(overlay)
      exceptInstance = overlay
    }
  })
  return exceptInstance
}

// 新建
const newInstance: any = ref(null)
const toDraw = () => {
  currentStep.value = OPEERATION_ENUM.NEW
  removeLocusList()

  const DrawType =
    locusTypeValue.value === LOCUS_SHAPE_TYPE.POLYGON
      ? L.Draw.Polygon
      : L.Draw.Circle
  const overlay = new DrawType(map, {
    showLength: true,
    showArea: true,
  })

  overlay.enable()
  newInstance.value = overlay
}
const onDrawCreated = (event: any) => {
  const overlay = event.layer
  let data = {}
  if (locusTypeValue.value === LOCUS_SHAPE_TYPE.POLYGON) {
    const points = overlay.getLatLngs()
    const pois = points[0].map(({ lng, lat }: any) => {
      return {
        longitude: lng,
        latitude: lat,
      }
    })
    data = {
      pois,
      aoiGraphCode: LOCUS_SHAPE_TYPE.POLYGON,
    }
  } else {
    const radius = overlay.getRadius()
    const { lat, lng } = overlay._latlng
    const roundData = {
      latitude: lat,
      longitude: lng,
      radius,
    }
    data = {
      roundData,
      aoiGraphCode: LOCUS_SHAPE_TYPE.ROUND,
    }
  }
  locusInfoConf.value = {
    visible: true,
    data,
  }
  overlay.remove()
}

const locusTypeChange = () => {
  newInstance.value?.remove?.()
  newInstance.value?.disable?.()

  toDraw()
}

// 编辑的实例
const editInstance: any = ref(null)
// 编辑围栏
const handleEdit = (locus: any) => {
  closeEdit()
  const overlay: any = removeLocusList(locus.id)
  currentStep.value = OPEERATION_ENUM.EDIT
  editInstance.value = locus
  const b = locusMap.value[locus.id].getBounds()
  map.fitBounds(b)
  overlay.editing.enable()
}
const completeEdit = () => {
  const instance = locusMap.value[editInstance.value.id]
  const aoiGraphCode = instance.aoiGraphCode
  if (aoiGraphCode === LOCUS_SHAPE_TYPE.POLYGON) {
    const points = instance?.getLatLngs()
    const pois = points[0].map(({ lng, lat }: any) => {
      return {
        longitude: lng,
        latitude: lat,
      }
    })
    toLocusAoiUpdate({
      pois,
      aoiGraphCode,
    })
  } else if (aoiGraphCode === LOCUS_SHAPE_TYPE.ROUND) {
    const radius = instance.getRadius()
    const { lat, lng } = instance._latlng
    toLocusAoiUpdate({
      aoiGraphCode,
      roundData: {
        latitude: lat,
        longitude: lng,
        radius,
      },
    })
  }

  instance.editing.disable()
}

const closeEdit = () => {
  // 新建的编辑也退出
  newInstance.value?.disable?.()
  newInstance.value?.remove?.()
  newInstance.value = null

  currentStep.value = OPEERATION_ENUM.EMPTY

  renderLocusList()
}

const selectLocus = (locus: any) => {
  const { id } = locus
  locusList.value.forEach((item: any) => {
    locusMap.value[item.id].setStyle({
      fillOpacity: item.id === id ? 0.7 : 0.1,
    })
  })
  moveLocusToCenter(locus)
}

// 移动中心点到围栏
const moveLocusToCenter = (locus: any) => {
  const instance = locusMap.value[locus.id]
  const b = instance.getBounds()
  map.fitBounds(b)
}

const onLocusInfoSuccess = () => {
  currentStep.value = OPEERATION_ENUM.EMPTY
  removeLocusList()
  fetchList()
}

// 编辑围栏基本信息
const handleEditBaseInfo = (locus: any) => {
  closeEdit()
  const { id } = locus
  locusList.value.forEach((item: any) => {
    locusMap.value[item.id].setStyle({
      fillOpacity: item.id === id ? 0.7 : 0.1,
    })
  })
  moveLocusToCenter(locus)
  locusInfoConf.value = {
    visible: true,
    data: locus,
  }
}

const removeConf = ref({
  visible: false,
  id: '',
})
const removeLoading = ref(false)
const toShowRemoveTips = (id: string) => {
  removeConf.value = {
    visible: true,
    id,
  }
}
const cancelRemove = () => {
  removeConf.value = {
    visible: false,
    id: '',
  }
}
// 删除围栏
const deleteLocus = async () => {
  closeEdit()
  removeLoading.value = true
  const res: any = await locusDelete({
    aoiIds: [removeConf.value.id],
  }).finally(() => {
    removeLoading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('D_LOCUS.delSuccess'))
    onLocusInfoSuccess()
    cancelRemove()
  }
}

const deviceList = ref([])
const queryDevice = async () => {
  const res: any = await queryAllDevice()
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceList.value = res?.data || []
    renderDevice()
  }
}

const renderDevice = () => {
  deviceList.value.forEach((device: any) => {
    const marker: any = createMarker(device)
    marker.addTo(map)
  })
}

const createMarker = (device: any) => {
  const { latitude, longitude, picCode } = device

  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [49, 62],
      iconAnchor: [25, 60],
      className: 'map-' + picCode,
    }),
  })

  const popup = createPopup(device)

  marker.bindPopup(popup)
  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    popup.setContent(`
      <div>${t('D_LOCATION.device')}：${device.deviceName}</div>
      <div>${t('D_LOCATION.address')}：${device.deviceAddress || '-'}</div>
      <div>${t('D_LOCATION.lat')}：${
      formatLat(device.latitude) + ' ' + device.latitude + '°'
    }</div>
      <div>${t('D_LOCATION.lng')}：${
      formatLng(device.longitude) + ' ' + device.longitude + '°'
    }</div>
      <div style="padding-bottom: 6px;">${t('D_LOCATION.time')}：${moment(
      device.updateTime
    ).format('YYYY-MM-DD HH:mm:ss')}</div>
    `)
    map.panTo(latlng)
    map.setView(latlng, 13)
    marker.openPopup()
  })

  return marker
}

const autoViewport = () => {
  // 根据设备定位给出视图
  if (locusList.value.length === 0) {
    const points = getPoints(deviceList.value)
    map.fitBounds(points)
  } else {
    // 根据围栏获取最佳视野
    const points = locusList.value.reduce((mo: any, el: any) => {
      mo = mo.concat(locusMap.value[el.id].getBounds())
      return mo
    }, [])
    map.fitBounds(points)
  }
}

const getPoints = (points: any) => {
  return points.map((device: any) => {
    const { longitude, latitude } = device
    return {
      lng: longitude,
      lat: latitude,
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_loading, false]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locusType.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["locus-type-box", {
          [item.class]: true,
          [item.class + '-active']: locusTypeActive(item.class),
          active: locusTypeActive(item.class),
        }]),
            onClick: ($event: any) => (changeLocusType(item.class))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ], 10, _hoisted_4))
        }), 128))
      ], 512), [
        [_vShow, currentStep.value === OPEERATION_ENUM.NEW]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(_component_el_button, {
          onClick: toDraw,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnNew')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, currentStep.value === OPEERATION_ENUM.EMPTY]
        ]),
        _withDirectives(_createVNode(_component_el_button, {
          onClick: closeEdit,
          type: "danger"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnClose')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, currentStep.value !== OPEERATION_ENUM.EMPTY]
        ]),
        _withDirectives(_createVNode(_component_el_button, {
          loading: editLoading.value,
          onClick: completeEdit,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnSave')), 1)
          ]),
          _: 1
        }, 8, ["loading"]), [
          [_vShow, currentStep.value === OPEERATION_ENUM.EDIT]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_select, {
            class: "ws_select_form",
            clearable: "",
            filterable: "",
            modelValue: filterLocus.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterLocus).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locusList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.aoiName,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterLocusList), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.id
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (selectLocus(item)),
              class: "card-title ws_mb16"
            }, [
              _createVNode(_unref(Text), {
                class: "aoiName",
                content: item.aoiName
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.aoiName), 1)
                ]),
                _: 2
              }, 1032, ["content"]),
              _createElementVNode("span", {
                class: _normalizeClass(["desc", {
              [getDirectionDesc(item.aoiDirectionCode, 'class')]: true,
              [getDirectionDesc(item.aoiDirectionCode, 'class') + '-r']:
                item.aoiGraphCode === _unref(LOCUS_SHAPE_TYPE).ROUND,
            }])
              }, _toDisplayString(getDirectionDesc(item.aoiDirectionCode, 'label')), 3)
            ], 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", {
                onClick: ($event: any) => (handleEdit(item))
              }, _toDisplayString(_ctx.$t('D_LOCUS.btnEdit')), 9, _hoisted_10),
              _createElementVNode("p", {
                onClick: ($event: any) => (handleEditBaseInfo(item))
              }, _toDisplayString(_ctx.$t('D_LOCUS.btnRelativeDevice')), 9, _hoisted_11),
              _createElementVNode("p", {
                class: "danger",
                onClick: ($event: any) => (toShowRemoveTips(item.id))
              }, _toDisplayString(_ctx.$t('D_LOCUS.btnDelete')), 9, _hoisted_12)
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, currentStep.value === OPEERATION_ENUM.EMPTY]
      ]),
      _createVNode(_unref(MapControl))
    ]),
    _createVNode(LocusInfo, {
      visible: locusInfoConf.value.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((locusInfoConf.value.visible) = $event)),
      data: locusInfoConf.value.data,
      onSuccess: onLocusInfoSuccess
    }, null, 8, ["visible", "data"]),
    _createVNode(_component_el_dialog, {
      modelValue: removeConf.value.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((removeConf.value.visible) = $event)),
      width: "500px",
      class: "ws_remove_dialog"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_icon, {
            color: "#F56C6C",
            size: "26",
            class: "ws_mr10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_WarningFilled)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('D_LOCUS.deleteTipTitle')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, { onClick: cancelRemove }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: removeLoading.value,
            type: "primary",
            onClick: deleteLocus
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnDelete')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('D_LOCUS.msgDeleteTip')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})